import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAnnouncements } from "../../api/announcementApi";
import "./AnnouncementBar.css";

const Message = ({ item }) => {
  if (!item.linkUrl) return <span className="ab-item">{item.text}</span>;
  // Same-site paths use the router; full URLs open normally.
  return item.linkUrl.startsWith("/") ? (
    <Link className="ab-item ab-link" to={item.linkUrl}>
      {item.text}
    </Link>
  ) : (
    <a className="ab-item ab-link" href={item.linkUrl} target="_blank" rel="noopener noreferrer">
      {item.text}
    </a>
  );
};

// The scrolling offer strip at the very top of every page. Its messages are
// managed from Admin -> Announcements. Renders nothing when there are none.
export default function AnnouncementBar() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    getAnnouncements().then((list) => {
      if (!cancelled) setItems(list);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (items.length === 0) return null;

  // The track holds the message list twice so the loop is seamless; the second
  // copy is hidden from assistive tech so it isn't read out twice.
  const renderCopy = (hidden) => (
    <div className="ab-group" aria-hidden={hidden || undefined}>
      {items.map((item) => (
        <React.Fragment key={`${hidden ? "b" : "a"}-${item.id}`}>
          <Message item={item} />
          <span className="ab-sep" aria-hidden="true">✦</span>
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <div className="ab-bar" role="region" aria-label="Offers and announcements">
      <div className="ab-track" style={{ "--ab-duration": `${Math.max(20, items.length * 14)}s` }}>
        {renderCopy(false)}
        {renderCopy(true)}
      </div>
    </div>
  );
}
